import { componentType } from "../helpers";
import { Slide } from "./imageSlides";
export default {
    type: componentType.Slide,
    component: Slide
};
